import React from 'react';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { render } from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ThemeDefault from 'layouts/material-admin/theme-default';
import styles from './styles/speedLegendStyles';
import Subheader from 'material-ui/Subheader';
import PinIcon from 'material-ui/svg-icons/av/fiber-manual-record';

/**
 * crea controllo centrale per ri-centrare la mappa
 * @param {*} translate
 * @param {*} map
 * @param {*} center
 */
export function createCenterControl(translate, map, center) {

    const google = window.google;
    var centerControlDiv = document.createElement('div');

    var controlUI = document.createElement('div');
    controlUI.style.backgroundColor = '#fff';
    controlUI.style.border = '2px solid #fff';
    controlUI.style.borderRadius = '3px';
    controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
    controlUI.style.cursor = 'pointer';
    controlUI.style.marginBottom = '22px';
    controlUI.style.textAlign = 'center';
    controlUI.title = translate('GLOBAL.centerMap');
    centerControlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    var controlText = document.createElement('div');
    controlText.style.color = 'rgb(25,25,25)';
    controlText.style.fontFamily = 'NeoSans, "Calibri Light", sans-serif';
    controlText.style.fontSize = '16px';
    controlText.style.lineHeight = '38px';
    controlText.style.paddingLeft = '5px';
    controlText.style.paddingRight = '5px';
    controlText.innerHTML = translate('GLOBAL.centerMap');
    controlUI.appendChild(controlText);

    // Setup the click event listeners: simply set the map to mapPosition.
    centerControlDiv.addEventListener('click', function () {
        map.setCenter(center);
    });

    centerControlDiv.index = 1;

    map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);
}

export function createSpeedLegendControl(translate, map, colorSpeedList, unitOfMeaserLabel){
    const google = window.google;

    const html =
    <MuiThemeProvider  muiTheme={ThemeDefault}>
        <div style={styles.divContainer} >
            <Paper style={styles.legendContainer} >
            <Subheader>
                {translate('LegendSpeed.title')}
            </Subheader>
            <div style={styles.menuContainer}>
                <Menu desktop={true}  >
                    {
                        colorSpeedList.map(item => (
                            <MenuItem key={item.speed}
                                leftIcon={
                                    <PinIcon
                                        style={{marginRight: 24}}
                                        color={item.color}
                                        />
                                }
                                primaryText={item.speed + ' ' + unitOfMeaserLabel}
                                style={styles.legendWidth}/>
                        ))
                    }
                </Menu>
            </div>

            </Paper>
        </div>
  </MuiThemeProvider>

    var legend = document.createElement('div');
    render(html, legend);
    map.controls[google.maps.ControlPosition.LEFT_CENTER].clear();
    map.controls[google.maps.ControlPosition.LEFT_CENTER].push(legend);
}


// WEBPACK FOOTER //
// ./src/services/maps/googleMapControlsServices.js